/**
 * Holds the credit score range for the different categories
 * (excellent, high, medium and low).
 */

export const CRIF_CREDIT_SCORE_RANGE = {
  excellent: '750+',
  high: '700 - 750',
  medium: '500 - 700',
  low: '<500',
}

export const EXPERIAN_CREDIT_SCORE_RANGE = {
  excellent: '750+',
  high: '700 - 749',
  medium: '601 - 699',
  low: '<601',
}

export enum CreditBureauExperimentName {
  ExperianRollout = 'ExperianRollout',
}
